import * as React from "react";

export const USFlag: React.FC = () => (
    <svg className="w-6 h-4" viewBox="0 0 24 16" fill="none">
        <rect width="24" height="16" fill="#B22234" />
        <path d="M0 1.85H24M0 3.69H24M0 5.54H24M0 7.38H24M0 9.23H24M0 11.08H24M0 12.92H24M0 14.77H24" stroke="white" strokeWidth="1.23" />
        <rect width="9.6" height="8.62" fill="#3C3B6E" />
    </svg>
);
